
import axios from "axios";
import React, { useState } from "react";
import { useLocation } from "wouter";
import Styles from "./Response.module.css"
import Animation1 from "../Animation/Animation2/Animation"
import Question from "../Question/Question";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
var ans = [];
var ans_1 = [];
// var ques = []
var qans = [false, false, false, false, false, false, false, false, false, false];
function Response(props) {
  const [data, setData] = useState(props.check.state);
  const [load, setLoad] = useState(true);
  const [played, setPlayed] = useState(false);
  const [ques, setQues] = useState();
  const [location, setLocation] = useLocation();
  const [user, setUser] = useState();
  const [allQues, setAllQues] = useState(null);
  if (!allQues) {
    setAllQues([Question(0), Question(1), Question(2)]);
  }
  // const [ques,setQues]  = useState([]);



  // Check Player Played or Not
  if (load && data.regid) {
    var formData = {
      regid: data.regid,
    };
    axios
      .post(data.apiUrl + "getCountPlay.php?key=" + data.publicKey, formData, {
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        if (res.data.length != 0) {
          setLoad(false);
          setPlayed(true);
        } else {
          alert("No Played");
          setLoad(false);
          setLocation("/quiz");
        }
      });
  }


  // Getting Player Response if he Played
  if (played) {
    axios
      .get(
        data.apiUrl + "getQueryData1.php?key=" + data.publicKey,
        props.check.state.config
      )
      .then((res) => {
        // console.log(res.data[0]);
        if (res.data) {
          var a = res.data[0];
          setUser(res.data);
          ans = [
            a.ans1,
            a.ans2,
            a.ans3,
            a.ans4,
            a.ans5,
            a.ans6,
            a.ans7,
            a.ans8,
            a.ans9,
            a.ans10,
          ];
          ans_1 = [
            a.ans1.trim().toLowerCase(),
            a.ans2.trim().toLowerCase(),
            a.ans3.trim().toLowerCase(),
            a.ans4.trim().toLowerCase(),
            a.ans5.trim().toLowerCase(),
            a.ans6.trim().toLowerCase(),
            a.ans7.trim().toLowerCase(),
            a.ans8.trim().toLowerCase(),
            a.ans9.trim().toLowerCase(),
            a.ans10.trim().toLowerCase(),
          ];
          setQues(allQues[(a.set * 1) - 1])
        }
        // console.log(ans);
      });
    setPlayed(false);
  }
  if (ques && ques.length > 0) {
    for (var i = 0; i < ques.length; i++) {
      var q = ques[i].ansOption.trim().toLowerCase();
      if (ques[i].type != "One Word") {
        qans[i] = q == ans_1[i];
      }
      else {
        qans[i] = (ans_1[i].includes(q) || q.includes(ans_1[i]))
      }
    }
  }
  // console.log(qans,ans_1);
  return (
    <>
      {load || played ? (
        <Animation1 />
      ) : (
        <>
          <div className={Styles.header}>
            <div className={Styles.title}>
              <span>Udaan</span>
              <span>Quizathon</span>
            </div>
            <div className={Styles.quit}></div>
          </div>
          <div className={Styles.tab}>
            <table>
              <tr>
                <th>Answer</th>
                <th>Response</th>
                <th>Status</th>
              </tr>
              {ques?.map((data, i) => (
                <tr
                  style={{
                    color:
                      ans[i] == "-1"
                        ? "grey"
                        : qans[i]
                          ? "#01ef01"
                          : "#f34a4a",
                  }}
                >
                  <th>{ques[i].ansOption}</th>
                  <th>{ans[i]}</th>
                  <th>
                    {ans[i] == "-1" ? (
                      <IndeterminateCheckBoxIcon />
                    ) : qans[i] ? (
                      <CheckCircleIcon />
                    ) : (
                      <CancelIcon />
                    )}
                  </th>
                </tr>
              ))}
            </table>
          </div>
        </>
      )}
    </>
  );
}

export default Response;
